import api, { API_POST_WWW_COMBINE, API_PUT_PATCH_WHITEBOARD_URL } from ".";

/**
 *
 * Do this because we want to tell backend that those url might have www msg history using extension
 */

// internal
// will be deleted

export async function postWWWCombine(url: string) {
  try {
    await api.post(API_POST_WWW_COMBINE, {
      url,
    });
  } catch (err) {}
}

/**
 *
 * Do this because we want to tell backend that those url is related to whiteboard
 */

// internal
// will be deleted

export async function putPatchWhiteboardUrl(url: string, room: string) {
  try {
    await api.put(API_PUT_PATCH_WHITEBOARD_URL + room, {
      url,
    });
  } catch (err) {}
}
